import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import NumberRen from "csi/heading/Number";
import locale from "csi/locale";
import InlineSelect from "csi/widget/InlineSelect";
import declare from "dojo/_base/declare";
import { DUE_DATE_OPTIONS, generateDojoStoreForDueDate } from "../ProofService";

export = declare(NumberRen, {
	/**
	 * @override
	 * custom the store
	 */
	toHtmlDynamic(ctx: Context, h: Heading, refNode: HTMLElement, params: { [propName: string]: any }) {
		if (params.value == null) {
			params.value = this._getValue(ctx, h);
		}

		params.store = generateDojoStoreForDueDate();
		params.value = (params.value == null) ? "" : String(params.value);

		return new InlineSelect(params);
	},

	/**
	 * @override
	 * return number instead to keep it consistent with DueDate on ProofStage
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: HTMLElement) {
		return Number(this.getEditorValue(ctx, editNode));
	},

	/**
	 * @override
	 * return a specific text
	 */
	formatValue(value: any, fmt: string) {
		const { res, resParams } = DUE_DATE_OPTIONS.find((item) => item.id == value);

		return locale.resource(res, resParams);
	},

	/**
	 * @override
	 * now that we override formatValue, should disable sort/filter functionality as well
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec) {
		return null;
	},

	/**
	 * @override
	 *  Use the InlineSelect widget as the editor
	 */
	useReactInlineDialog() {
		return false;
	},
});